import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Expense } from '@/types/settings';

export function usePayReimbursement(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<Expense, string>({
    mutationFn: (id) =>
      apiPatch<Expense>(operationsClient, expenseEndpoints.reimbursementPay(jobId, id)),
    onSuccess: (_expense, id) => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      toast.success('Reimbursement marked paid');
    },
  });
}
